import LoopingEllipsis from '@/components/LoopingEllipsis';
import { classes } from './utils';

// Tailwind-only + dark-aware to avoid a hydration mismatch after the no-flash script sets `dark`.
export default function LoadingApp() {
  return (
    <div className={classes.wrapper}>
      <div className={classes.card}>
        <span>Loading</span>
        <LoopingEllipsis />
      </div>
    </div>
  );
}
